import { render, staticRenderFns } from "./StudyReportPage.vue?vue&type=template&id=3436d8c0&scoped=true&"
import script from "./StudyReportPage.vue?vue&type=script&lang=ts&"
export * from "./StudyReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3436d8c0",
  null
  
)

export default component.exports